module.exports = __webpack_public_path__ + "static/media/home2.aa3820bd.svg";